export default [
  { value: '-5/+5', label: '-5/+5' },
  { value: '-10/+10', label: '-10/+10' },
  { value: '-20/+10', label: '-20/+10' },
  { value: '-30/+10', label: '-30/+10' },
];
